<div class="sale-result">
  <div class="container-fluid p-0" >
   
    <div class="bg-white p-3 mt-3">
      <div class="row ps-1 pe-1">
        <div class="col-md-2 col-sm-12 mb-1">
          <h1>
            All Sales <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
          </h1>
        </div>

        <div class="col-md-10 col-sm-12">
          <div class="row g-3 flex justify-content-end">
            <div class="col-3">
              <app-search-box placeholder="Search..."
                              (searchChange)="filterSale($event)">
              </app-search-box>

            </div>
            <!-- <div class="col-auto">
              <button type="button" class="btn btn-primary btn-filter">
                <i class="fa fa-filter" aria-hidden="true"></i>
              </button>
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-primary">
                <i class="fa fa-check-square-o" aria-hidden="true"></i>
                Pre-Load Selected Horses
              </button>
            </div> -->
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-12">
          <div class="flex justify-content-center">
            <div class="btn-group mt-1" role="group" aria-label="Basic example">
              <button type="button"
                      class="btn btn-outline-primary btn-sm rounded-first btn-first fs-13"
                      [ngClass]="{ active: tab === null }"
                      (click)="onSelectSales()">
                All ({{ allSales?.length }})
              </button>
              <button type="button"
                      class="btn btn-outline-primary btn-sm fs-13"
                      (click)="onSelectSales(SaleTypes.CURRENT)"
                      [ngClass]="{ active: tab === SaleTypes.CURRENT }">
                Current ({{ currentSales?.length }})
              </button>

              <button type="button"
                      class="btn btn-outline-primary btn-sm fs-13"
                      [ngClass]="{ active: tab === SaleTypes.FUTURE }"
                      (click)="onSelectSales(SaleTypes.FUTURE)">
                Upcoming ({{ futureSales?.length }})
              </button>
              <button type="button"
                      class="btn btn-outline-primary btn-sm rounded-last btn-last fs-13"
                      [ngClass]="{ active: tab === SaleTypes.PAST }"
                      (click)="onSelectSales(SaleTypes.PAST)">
                Past ({{ pastSales?.length }})
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive data-grid sticky-header-table sticky-header-table-height-lg mt-4"
           #table>
        <table mat-table
               [dataSource]="dataSource"
               class="table sale-table"
               matSort
               infiniteScroll
               [infiniteScrollDistance]="2"
               [infiniteScrollThrottle]="20"
               [infiniteScrollContainer]="table"
               [fromRoot]="true"
               (scrolled)="onTableScroll()">
          <ng-container matColumnDef="saleImageUrl">
            <th mat-header-cell
                class="sale-image-heading w-3 pe-2"
                *matHeaderCellDef
                mat-sort-header></th>
            <td mat-cell *matCellDef="let element" class="py-2 pe-2">
              <img [src]="element?.saleImageUrl"
                   *ngIf="element?.saleImageUrl; else placeholder"
                   width="45" />

              <ng-template #placeholder>
                <img src="assets/images/horse-no-img.jpg"
                     class="default-img"
                     width="45" />
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="saleName">
            <th mat-header-cell
                class="sale-name-heading w-10"
                *matHeaderCellDef
                mat-sort-header>
              sale <i class="fa fa-sort ms-1"></i>
            </th>
            <td mat-cell *matCellDef="let element" class="less-height-1-8-rem">
              <div class="border-0 ps-0">
                <div class="title-wrap d-sm-flex align-items-center">
                  <div class="sale-title" style="position: relative">
                    <span (click)="openSaleTermsConditionPopup(element)"
                          *ngIf="element.saleMemberStatusId === 3"
                          class="cursor-pointer text-primary fw-bold">
                      {{ element?.saleName }}
                    </span>
                    <span *ngIf="element.saleMemberStatusId !== 3"
                          class="cursor-pointer text-primary fw-bold">
                      {{ element?.saleName }}
                    </span><br />
                    <span>{{ element?.location }}</span>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="saleHorseCount">
            <th mat-header-cell
                class="repository-location-name-heading  w-5"
                *matHeaderCellDef
                mat-sort-header>
              horses
            </th>
            <td mat-cell *matCellDef="let element" class="ps-2">
              {{ element.saleHorseCount }}
            </td>
          </ng-container>

          <!--<ng-container matColumnDef="dateRange">
    <th
      mat-header-cell
      class="date-range-heading w-0-5-rem"
      *matHeaderCellDef
      mat-sort-header
    >
      Date Range
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      class="less-height-2-rem pt-2"
    >
      <div>
        {{ element?.startDate | date : getSaleDateFormat(element) }}
      </div>
      <div>
        {{ element?.endDate | date : getSaleDateFormat(element) }}
      </div>
    </td>
  </ng-container>-->

          <ng-container matColumnDef="repositoryLocation">
            <th mat-header-cell
                class="repository-location-name-heading w-3"
                *matHeaderCellDef
                mat-sort-header>
              Repo Location
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.repositoryLocation }}
            </td>
          </ng-container>

          <ng-container matColumnDef="accessionPrefix">
            <th mat-header-cell
                class="accession-prefix-heading w-3"
                *matHeaderCellDef
                mat-sort-header>
              Accession
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.accessionPrefix }}
            </td>
          </ng-container>

          <ng-container matColumnDef="startDate">
            <th mat-header-cell
                class="x-raying-may-commence-heading w-7"
                *matHeaderCellDef
                mat-sort-header>
              X-Ray Commence
            </th>
            <td mat-cell
                *matCellDef="let element"
                class="less-height-2-rem pt-2 ps-3">
              <span *ngIf="
                  element.xrayCommenceDates !== null
                ">
                {{
                  element?.xrayCommenceDates?.startDate
                    | date : getSaleDateFormat(element)
                }}

              </span>
              <br />
              <span *ngIf="!isTimeEqualsTo12AM(element?.xrayCommenceDates?.startDate| date : 'h:mm a')">
                {{
                  element?.xrayCommenceDates?.startDate
                    | date : 'h:mm a'
                }}
              </span>

            </td>
          </ng-container>

          <ng-container matColumnDef="lodgeBefore">
            <th mat-header-cell
                class="lodge-before-heading w-7"
                *matHeaderCellDef
                mat-sort-header>
              Submissions
            </th>
            <td mat-cell
                *matCellDef="let element"
                class="less-height-2-rem pt-2 ps-1">


              <span *ngIf="
                  element.submissionDates !== null
                ">
                {{
                  element?.submitStartDate
                    | date : getSaleDateFormat(element)
                }}

              </span>
              <br />
              <span *ngIf="!isTimeEqualsTo12AM(element?.submissionDates?.startDate| date : 'h:mm a')">
                {{
                  element?.submitStartDate
                    | date : 'h:mm a'
                }}
              </span>

            </td>
          </ng-container>


          <ng-container matColumnDef="viewStartDate">
            <th mat-header-cell
                class="lodge-before-heading w-7"
                *matHeaderCellDef
                mat-sort-header>
              Viewing
            </th>
            <td mat-cell
                *matCellDef="let element"
                class="less-height-2-rem pt-2 ps-1">

              <span *ngIf="
                  element.viewStartDate !== null
                ">
                {{
                  element?.viewStartDate
                    | date : getSaleDateFormat(element)
                }}

              </span>
              <br />
              <span *ngIf="!isTimeEqualsTo12AM(element?.viewStartDate| date : 'h:mm a')">
                {{
                  element?.viewStartDate
                    | date : 'h:mm a'
                }}
              </span>


            </td>
          </ng-container>

          <ng-container matColumnDef="sellingStartDate">
            <th mat-header-cell
                class="lodge-before-heading w-7"
                *matHeaderCellDef
                mat-sort-header>
              Selling
            </th>
            <td mat-cell
                *matCellDef="let element"
                class="less-height-2-rem pt-2 ps-1">

              <span *ngIf="
                  element.sellingStartDate !== null
                ">
                {{
                  element?.sellingStartDate
                    | date : getSaleDateFormat(element)
                }}

              </span>
              <br />
              <span *ngIf="!isTimeEqualsTo12AM(element?.sellingStartDate| date : 'h:mm a')">
                {{
                  element?.sellingStartDate
                    | date : 'h:mm a'
                }}
              </span>


            </td>
          </ng-container>

          <ng-container matColumnDef="deadlines">
            <th mat-header-cell
                class="lodge-before-heading w-3"
                *matHeaderCellDef
                mat-sort-header>
              Deadlines
            </th>
            <td mat-cell
                *matCellDef="let element"
                class="less-height-2-rem pt-2 ps-1">
              <a (click)="openDeadLinePopup(element)" href="javascript:void(0)">
                <img src="assets/images/calendar-icon.svg"
                     class="default-img"
                     width="30" height="30" />

              </a>
            </td>
          </ng-container>


          <ng-container matColumnDef="action">
            <th mat-header-cell
                class="action-heading w-5"
                *matHeaderCellDef
                mat-sort-header></th>
            <td mat-cell *matCellDef="let element">
              <div class="table-button-wrapper flex justify-content-end">
                <a routerLink="{{ element.saleId }}/sale-settings"
                   *ngIf="isSalesEditor"
                   title="View Sale Settings"
                   class="btn btn-outline-primary btn-sm btn-view me-1">
                  <i class="fa fa-cogs"></i>
                </a>
                <button type="button"
                        *ngIf="element.saleMemberStatusId === 3 && !isSalesEditor"
                        class="btn btn-success btn-sm btn-view me-1"
                        (click)="openSaleTermsConditionPopup(element)">
                  View Sale
                </button>

                <button type="button"
                        *ngIf="(element | saleRequestAccessPipe) && !isSalesEditor"
                        class="btn btn-secondary btn-sm btn-view me-1"
                        (click)="sendSaleMemberRequest(element)">
                  Request Access
                </button>
                <button type="button"
                        *ngIf="element.saleMemberStatusId === 4 && !isSalesEditor"
                        class="btn btn-danger btn-sm btn-view me-1"
                        (click)="viewComments(element)">
                  Denied
                </button>
                <button type="button"
                        *ngIf="element.saleMemberStatusId === 5 && !isSalesEditor"
                        class="btn btn-warning btn-sm btn-view me-1">
                  Pending
                </button>
                <button type="button"
                        *ngIf="element.saleMemberStatusId === -1 && !isSalesEditor"
                        class="btn btn-info btn-sm btn-view me-1"
                        (click)="acceptSaleInvitation(element)">
                  {{ element.saleMemberStatus }}
                </button>
                <a routerLink="/statistics/sale/{{ element.saleUID }}"
                   *ngIf="isSalesCompany"
                   class="btn btn-outline-primary btn-sm btn-view"
                   title="View Sale Statistics">
                  <i class="fas fa-chart-bar"></i>
                </a>
                <button type="button"
                        *ngIf="isSalesCompany"
                        class="btn btn-outline-primary btn-sm btn-view ms-1"
                        (click)="openMediaConversionLogModal(element)"
                        title="View Media Conversion Logs">
                  <i class="fa fa-file-video"></i>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row
              *matRowDef="
              let row;
              columns: displayedColumns;
              let saleIndex = index
            "
              class="border-start-0 border-end-0 pointer pt-2"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
